<template>
  <!-- FAQ -->
  <div class="faq">
    <header class="header">
      <p>よくある質問</p>
    </header>
    <div class="faq-accordion">
      <section v-for="(qa, index) in qaList" :key="index">
        <input
          :id="'faq-' + `${index}`"
          type="checkbox"
          class="toggle"
          :class="['toggle' + index]"
        />
        <label class="label" :for="'faq-' + `${index}`"
          ><p><span>Q </span>{{ qa.q }}</p></label
        >
        <div class="faq-content"><span>A </span>{{ qa.a }}</div>
      </section>
    </div>
    <div class="footer">
      <common-button
        :data="{
          status: 0,
          button: `お問い合わせはこちら`,
        }"
        @click="contact()"
      ></common-button>
    </div>
  </div>
  <contact-dialog ref="dialog" v-model="showDialog"></contact-dialog>
</template>

<script setup lang="ts">
import ContactDialog from "./ContactDialog.vue";
import { ref } from "vue";
import CommonButton from "./CommonButton.vue";

const dialog = ref<InstanceType<typeof ContactDialog>>();
const showDialog = ref(false);
const qaList = [
  {
    q: "どのように応募すればよいですか？",
    a: "案件画面下の「応募」ボタンからお願いします",
  },
  {
    q: "下書きの確認中に掲載期日が過ぎてしまい、投稿していいのかが分からない",
    a: "クライアント企業様の状況により、掲載期日が過ぎている状態でも下書きのお戻しが遅くなる場合がございます。その際は下書きの確認が完了してからの投稿で問題ございません。※クライアント企業様のInstagramアカウントへのDM等、直接の連絡はご遠慮いただけますと幸いです。※SPADアプリ内、弊社公式Instagramアカウント、LINE公式アカウントのいずれかより、別途ご案内させていただく場合がございます。その際には案内に従っていただけますと幸いです。ご不明な点ありましたら、下記よりお問い合わせいただけますと幸いです。",
  },
  {
    q: "お支払い通知書はいつ発行されるか",
    a: "案件終了後の翌月の20日前後に発行されます。例えば、10月1日に案件が終了した場合は、11月20日前後の支払い通知書発行となります。",
  },
  {
    q: "弊社案件の報酬のお支払日は投稿月の翌月末となります。",
    a: "件終了後の翌月の20日前後に発行されます。",
  },
  {
    q: "お支払金額として記載された金額は報酬として貰える金額、自分が支払う金額のどちらでしょうか",
    a: "案件を実施した際にOMOTinfluencerからインフルエンサーの方に対してお支払する金額になります。",
  },
  {
    q: "フォロワー数と投稿数が更新されない",
    a: "フォロワー数と投稿数はリアルタイムには反映されません。",
  },
];

const contact = () => {
  showDialog.value = true;
  dialog.value?.openContactDialog();
};
// import { router } from 'vue-router'
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/_mixin.scss";
@mixin span() {
  color: #086eb6;
  font-weight: 700;
  font-size: $FONT_SIZE_M;
  padding-right: 13px;
}
.faq {
  position: relative;
  @include container();
  background-color: $white !important;
}
.header {
  @include header();
}
.faq-accordion {
  width: 100%;
  position: absolute;
  top: 80px;
  bottom: 70px;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.faq-accordion::-webkit-scrollbar {
  display: none;
}

.toggle {
  display: none;
}
.label {
  /*タイトル*/
  padding: 1em;
  display: block;
  color: #333333;
  p {
    padding-right: 30px;
    span {
      @include span();
    }
  }
}
.label::before {
  /*タイトル横の矢印*/
  content: "";
  width: 5.5px;
  height: 5.5px;
  border-top: 1.8px solid #acacac;
  border-right: 1.8px solid #acacac;
  transform: rotate(45deg);
  position: absolute;
  top: calc(50% - 3px);
  right: 20px;
}
.label,
.faq-content {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform: translateZ(0);
  transition: all 0.3s;
}
.faq-content {
  /*本文*/
  height: 0;
  // margin-bottom: 10px;
  padding: 0 20px;
  overflow: hidden;
}
.toggle:checked + .label + .faq-content {
  /*開閉時*/
  height: auto;
  padding: 20px;
  transition: all 0.3s;
  background-color: #f1f6fa;
  span {
    @include span();
  }
}
.toggle:checked + .label::before {
  transform: rotate(135deg) !important;
}
.footer {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
  position: fixed;
  bottom: 15px;
}
</style>
